import { render, staticRenderFns } from "./BulkDeleteProcessingState.vue?vue&type=template&id=48c1fd3e&scoped=true"
import script from "./BulkDeleteProcessingState.vue?vue&type=script&lang=js"
export * from "./BulkDeleteProcessingState.vue?vue&type=script&lang=js"
import style0 from "./BulkDeleteProcessingState.vue?vue&type=style&index=0&id=48c1fd3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c1fd3e",
  null
  
)

export default component.exports